<!-- Loading Spinner -->
<div *ngIf="isLoading" class="d-flex justify-content-center my-5">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading" class="container mt-4 pb-5">

  <!-- Header: Title + Right Side Controls -->
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
    <h4 class="mb-0">💳 Cards Details</h4>

    <div class="d-flex align-items-center gap-3 flex-wrap">
      <div class="form-check form-switch autopay-switch d-flex align-items-center mb-0">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="isAutoPaymentEnabled"
          (change)="toggleAutoPay()"
          id="autopaySwitch"
        />
        <label class="form-check-label ms-2 mb-0" for="autopaySwitch">
          Autopay
        </label>
      </div>

      <button class="btn" (click)="openPaymentModal(paymentModal)">
        <i class="fa fa-plus me-1"></i> Add New Card
      </button>
    </div>
  </div>

  <!-- Card Table -->
  <div *ngIf="savedCards?.length > 0; else noCards">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle shadow-sm">
        <thead class="thead-dark">
          <tr>
            <th scope="col" class="text-center">Select</th>
            <th scope="col">Card Scheme</th>
            <th scope="col">Masked Card</th>
            <th scope="col" class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let card of savedCards">
            <td class="text-center">
              <input
                type="radio"
                name="selectedCard"
                [(ngModel)]="selectedCardId"
                [value]="card?.cardId"
                (change)="onCardSelected(card)"
                [checked]="card?.isDefault"
              />
            </td>
            <td>{{ card?.cardScheme | titlecase }}</td>
            <td>{{ card?.maskedCard }}</td>
            <td class="text-center">
              <img
                (click)="onDeleteCard(card)"
                style="cursor: pointer"
                src="../../../../assets/images/ic_delete.png"
                alt="Delete"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Cards Template -->
  <ng-template #noCards>
    <div class="alert alert-info shadow-sm">
      No saved cards found. Please add a new card.
    </div>
  </ng-template>

  <!-- Proceed Button -->
  <div *ngIf="bookingDetailId" class="d-flex align-items-center justify-content-end mt-4">
    <button
      class="btn btn-success"
      [disabled]="!selectedCardId || !defaultCardSet"
      (click)="payPaymentWithCard(selectedCardId)"
    >
      Proceed to Payment
    </button>
  </div>
</div>

<!-- Add Card Modal -->
<ng-template #paymentModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Enter Card Details</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="cardholderName" class="font-weight-bold">
        Name on Card <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        id="cardholderName"
        class="form-control"
        [(ngModel)]="cardholderName"
        name="cardholderName"
        required
        [ngClass]="{ 'is-invalid': nameTouched && !cardholderName }"
        (blur)="nameTouched = true"
        placeholder="Enter name as printed on card"
      />
      <div *ngIf="nameTouched && !cardholderName" class="invalid-feedback">
        Name on card is required.
      </div>
    </div>

    <div id="card-element" class="mt-4 border rounded p-2 shadow-sm"></div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-success" (click)="submitPayment(modal)">
      Submit
    </button>
  </div>
</ng-template>
